<form [formGroup]="form"
  (submit)="onSubmit()">
  <div fxLayout="column"
    fxLayoutAlign="start stretch">

    <div *ngIf="error">
      {{ error }}
    </div>

    <div fxLayout="row"
      fxLayout.lt-md="column"
      fxLayoutGap="20px">

      <div fxFlex="grow">
        <h2>Community Profile</h2>

        <div fxLayout="column">
          <mat-form-field>
            <input matInput
              type="text"
              class="input-wide"
              placeholder="First Name"
              formControlName="firstName">
          </mat-form-field>
          <mat-form-field>
            <input matInput
              type="text"
              class="input-wide"
              placeholder="Last Name"
              formControlName="lastName">
          </mat-form-field>
          <mat-form-field class="input-wide">
            <input matInput
              type="text"
              class="input-wide"
              placeholder="Date of Birth"
              [value]="form.value.dateOfBirth | moment:'parse':'YYYY-MM-DD' | moment:'format':'DD/MM/YYYY'"
              readonly
              (click)="dobPicker.open()">
            <input class="hidden-field"
              [matDatepicker]="dobPicker"
              formControlName="dateOfBirth">
            <mat-datepicker-toggle matSuffix
              [for]="dobPicker">
            </mat-datepicker-toggle>
            <mat-datepicker #dobPicker
              [startAt]="startDate"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="input-wide">
            <textarea matInput
              rows="8"
              type="text"
              class="input-wide"
              placeholder="Profile"
              formControlName="about">
            </textarea>
          </mat-form-field>
        </div>

        <div class="input-group">
          <ca-photo-picker [queryString]="queryString"
            formControlName="profileImage"
            title="Profile Image"></ca-photo-picker>
        </div>

      </div>

      <div fxFlex="grow">
        <h2>Contact Information</h2>
        <div formGroupName="address">
          <div class="input-group"
            fxLayout="column">
            <mat-form-field>
              <input matInput
                type="text"
                class="input-wide"
                placeholder="Address Line 1"
                formControlName="address1">
            </mat-form-field>
          </div>
          <div class="input-group"
            fxLayout="column">
            <mat-form-field>
              <input matInput
                type="text"
                class="input-wide"
                placeholder="Address Line 2"
                formControlName="address2">
            </mat-form-field>
          </div>
          <div class="input-group"
            fxLayout="column">
            <mat-form-field>
              <input matInput
                type="text"
                placeholder="Town / Suburb"
                formControlName="town">
            </mat-form-field>
          </div>
          <div class="input-group"
            fxLayout.lt-lg="column"
            fxLayout="row">
            <mat-form-field>
              <input matInput
                type="text"
                placeholder="State"
                formControlName="state">
            </mat-form-field>
            <mat-form-field>
              <input matInput
                type="text"
                class="input-narrow "
                placeholder="Postcode"
                formControlName="postcode">
            </mat-form-field>
          </div>
          <div class="input-group"
            fxLayout="column">
            <mat-form-field>
              <input matInput
                type="text"
                class="input-wide"
                placeholder="Country"
                formControlName="country">
            </mat-form-field>
          </div>
        </div>
      </div>

      <div fxFlex="grow">
        <h2>Location</h2>
        <div formGroupName="location"
          fxLayout="row"
          fxLayout.lt-lg="column">
          <mat-form-field>
            <input matInput
              type="text"
              class="input-narrow"
              formControlName="lat"
              placeholder="Lat">
          </mat-form-field>
          <mat-form-field>
            <input matInput
              type="text"
              class="input-narrow"
              formControlName="lng"
              placeholder="Long">
          </mat-form-field>
          <button mat-icon-button
            [disabled]="locationLoading"
            (click)="findLocation()"
            type="button">
            <mat-icon aria-label="Lookup Address">search</mat-icon>
          </button>

        </div>
        <div class="map-holder">

          <agm-map [latitude]="form.get('location')?.get('lat')?.value"
            [longitude]="form.get('location')?.get('lng')?.value"
            [zoom]="15">
            <agm-marker [latitude]="form.get('location')?.get('lat')?.value"
              [longitude]="form.get('location')?.get('lng')?.value">
            </agm-marker>
          </agm-map>
        </div>
        <mat-progress-bar mode="indeterminate"
          [style.visibility]="locationLoading ? 'visible' : 'hidden'"></mat-progress-bar>

      </div>
    </div>
    <div fxFlex
      fxFlexFill></div>
    <div fxFlexAlign="end">
      <button [disabled]="loading"
        role="button"
        color="primary"
        mat-flat-button>{{ mode == FormMode.CREATE ? 'Create Community' : 'Save' }}</button>
    </div>
  </div>
</form>